import React, {useMemo} from 'react'
import {useGameTimer} from '../../hooks/useGameTimer'
import {useGameStore} from '../../store/GameStoreContext'
import {UIGameTimerBar} from './UIGameTimerBar'

export const UIGameTimerBarContainer = () => {
    const currentTurnPlayerColor = useGameStore((state) => state.gameState.currentState.currentTurnPlayerColor)
    const timeLeftInSeconds = useGameStore((state) => state.timeLeftInSeconds)
    const allocatedTime = useGameStore((state) => state.gameState.currentState.allocatedTime)
    const isPaused = useGameStore((state) => state.gamePause.isPaused)
    const liveTimeLeftInSeconds = useGameTimer({
        timeLeftInSeconds: timeLeftInSeconds,
        isPaused: isPaused,
    })

    const timeLeftPercentage = useMemo(() => liveTimeLeftInSeconds / allocatedTime * 100, [liveTimeLeftInSeconds, allocatedTime])

    return (
        <UIGameTimerBar
            currentTurnPlayerColor={currentTurnPlayerColor}
            timeLeftPercentage={timeLeftPercentage}
            isAnimated={true} />
    )
}
